import DataRetriever from '../DataRetriever.js';
import DataImplementation from '../data/DataImplementation.js';
import DataReferenceCollection from '../data/DataReferenceCollection.js';
import FeatureReference from '../features/FeatureReference.js';
import ColumnCoverage from './ColumnCoverage.js';
import FeatureAvailability from './FeatureAvailability.js';
class AvailabilityManager {
    constructor() {
        this.available = [];
        this.unavailable = [];
    }
    /**
     * @param {number[]} columnIDs
     * @return {Promise<ColumnCoverage[]>}
     */
    forColumns(columnIDs) {
        return Promise.all([
            this.load(),
            ColumnCoverage.allForColumns(columnIDs),
        ])
            .then((results) => results[1]);
    }
    /**
     * @param {FeatureSpecifier} feature
     * @return {Promise<*>}
     */
    forFeature(feature) {
        const ref = FeatureReference.fromKey(feature.key);
        const isSystemFeature = ref.type === FeatureReference.SourceType.SYSTEM;
        return Promise.all([
            this.load(),
            FeatureAvailability.forFeature(feature),
        ])
            .then((results) => {
            const availability = results[1];
            return isSystemFeature ? availability[ref.sourceId] : null;
        });
    }
    /**
     * @param {features.FeatureReferenceCollection[]} featureReferenceCollections
     * @param {system-metadata.Column[]} columns
     */
    forFeatureReferenceCollections(featureReferenceCollections, columns) {
        const references = columns.map((column) => column.toDataReference());
        const collection = DataReferenceCollection.fromDataReferences(references);
        const implementation = new DataImplementation({ ref: collection });
        const retrieve = featureReferenceCollections.map((featureReferenceCollection) => (new DataRetriever(featureReferenceCollection, [implementation]).retrieve()));
        return Promise.all(retrieve).then((results) => {
            const combined = results.reduce((memo, { values }) => ({ ...memo, ...values }), {});
            const features = results.reduce((memo, result) => [...memo, ...result.featureCollection.features], []);
            return {
                features,
                values: new DataRetriever.ValueCollection(combined),
            };
        });
    }
    /**
     */
    load() {
        return Promise.all([
            ColumnCoverage.where({ coverageRatio: 0 }),
            ColumnCoverage.where({ coverageRatio: 1 }),
        ])
            .then(([unavailable, available]) => {
            this.unavailable = unavailable;
            this.available = available;
            return {
                available,
                unavailable,
            };
        });
    }
}
export default AvailabilityManager;
